"use client";

import { useEffect, useRef } from "react";
import { toast } from "sonner";
import { useAffiliateRef } from "@/hooks/use-affiliate-ref";
import { GREEN, YELLOW } from "@/lib/constants";

async function fireConfetti() {
  const { default: confetti } = await import("canvas-confetti");
  confetti({
    particleCount: 80,
    spread: 60,
    origin: { x: 0.98, y: 0.02 },
    angle: 220,
    // the accent pair from the source of truth, so a palette change lands here too
    colors: [YELLOW, "#ffffff", GREEN, YELLOW],
    scalar: 0.9,
    zIndex: 9999,
  });
}

const SHOWN_KEY = "affwp_toast_shown";

export default function AffiliateBanner() {
  const { valid, ref, couponCode, discountRate, isLoading } = useAffiliateRef();
  const fired = useRef(false);

  useEffect(() => {
    if (isLoading || !valid || fired.current) return;
    const storageKey = `${SHOWN_KEY}_${ref ?? couponCode ?? "default"}`;
    if (localStorage.getItem(storageKey)) return;
    fired.current = true;
    localStorage.setItem(storageKey, "1");

    const title = "🎉 Exclusive partner deal";
    const description = couponCode
      ? `Use code ${couponCode}${discountRate ? ` for ${discountRate} off` : ""} at checkout`
      : "Special pricing activated for you";

    void fireConfetti();

    toast(title, {
      description,
      duration: 8000,
      style: {
        background: "var(--background)",
        color: "var(--foreground)",
        border: `1px solid ${GREEN}40`,
        boxShadow: `0 8px 32px -8px ${GREEN}33`,
      },
      classNames: {
        title: "!text-foreground !font-semibold",
        description: "!text-muted-foreground",
        actionButton: "!bg-primary !text-primary-foreground !font-semibold hover:!opacity-90",
      },
      ...(couponCode && {
        action: {
          label: "Copy code",
          onClick: () => navigator.clipboard.writeText(couponCode).catch(() => null),
        },
      }),
    });
  }, [valid, isLoading, couponCode, discountRate]);

  return null;
}
